"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _mapping = require("@nicbase/mapping");

var _nicbaseConversion = require("nicbase-conversion");

var _nicbaseReducers = require("nicbase-reducers");

var _nicbaseTranslation = require("nicbase-translation");

var _constants = require("../../constants");

var _tourLocationBlock = _interopRequireDefault(require("./tour-location-block"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var LatestDataDetails = function LatestDataDetails(_ref) {
  var tour = _ref.tour,
      latestData = _ref.latestData;

  var _useUser = (0, _nicbaseReducers.useUser)(),
      temperatureUnit = _useUser.temperatureUnit;

  var _latestData$common = latestData.common,
      common = _latestData$common === void 0 ? {} : _latestData$common,
      _latestData$reefer = latestData.reefer,
      reefer = _latestData$reefer === void 0 ? {} : _latestData$reefer,
      _latestData$position = latestData.position,
      position = _latestData$position === void 0 ? {} : _latestData$position,
      _latestData$pois = latestData.pois,
      pois = _latestData$pois === void 0 ? [] : _latestData$pois;
  var _common$status = common.status,
      status = _common$status === void 0 ? [] : _common$status;

  var _ref2 = position !== null && position !== void 0 ? position : {},
      _ref2$properties = _ref2.properties,
      properties = _ref2$properties === void 0 ? {} : _ref2$properties;

  var _reefer$setpoints = reefer.setpoints,
      setpoints = _reefer$setpoints === void 0 ? {} : _reefer$setpoints,
      _reefer$temperatures = reefer.temperatures,
      temperatures = _reefer$temperatures === void 0 ? {} : _reefer$temperatures;
  var _properties$address = properties.address,
      address = _properties$address === void 0 ? {} : _properties$address;
  var _address$number = address.number,
      number = _address$number === void 0 ? null : _address$number,
      _address$postalCode = address.postalCode,
      postalCode = _address$postalCode === void 0 ? null : _address$postalCode,
      _address$city = address.city,
      city = _address$city === void 0 ? null : _address$city,
      _address$countryCode = address.countryCode,
      countryCode = _address$countryCode === void 0 ? null : _address$countryCode,
      _address$street = address.street,
      street = _address$street === void 0 ? null : _address$street;

  if (tour.status !== _constants.TOUR_STATUS.RUNNING) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "pt-5 pr-0 pb-2 pl-5"
    }, /*#__PURE__*/_react["default"].createElement(_tourLocationBlock["default"], {
      status: tour.status
    }));
  }

  var latestDataStatus = status.map(function (st) {
    return /*#__PURE__*/_react["default"].createElement(_mapping.Status, {
      key: st.type,
      className: "mr-2",
      status: st
    });
  });
  var setpointContent = Object.entries(setpoints).map(function (_ref3, index) {
    var _ref4 = _slicedToArray(_ref3, 2),
        setpointKey = _ref4[0],
        setpointValue = _ref4[1];

    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex",
      key: setpointKey
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.details.label.reefer.setpoint"
    }, function (value) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "mr-1"
      }, value, " ", setpointKey, ":");
    }), /*#__PURE__*/_react["default"].createElement(_nicbaseConversion.FormattedUnit, {
      value: setpointValue,
      from: "degC",
      to: temperatureUnit,
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
      roundValue: true
    }), index < Object.keys(setpoints).length - 1 && /*#__PURE__*/_react["default"].createElement("p", {
      className: "whitespace-pre-wrap"
    }, " | "));
  });
  var temperatureContent = Object.entries(temperatures).map(function (_ref5, index, array) {
    var _ref6 = _slicedToArray(_ref5, 2),
        temperatureKey = _ref6[0],
        temperatureValue = _ref6[1];

    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex",
      key: temperatureKey
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.details.label.temp"
    }, function (value) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "mr-1"
      }, value, " ", temperatureKey, ":");
    }), /*#__PURE__*/_react["default"].createElement(_nicbaseConversion.FormattedUnit, {
      value: temperatureValue,
      from: "degC",
      to: temperatureUnit,
      minimumFractionDigits: 1,
      maximumFractionDigits: 1
    }), index !== array.length - 1 && /*#__PURE__*/_react["default"].createElement("p", {
      className: "whitespace-pre-wrap"
    }, " | "));
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "pt-5 pr-0 pb-2 pl-5"
  }, /*#__PURE__*/_react["default"].createElement(_tourLocationBlock["default"], {
    status: tour.status,
    pois: pois,
    number: number,
    postalCode: postalCode,
    city: city,
    countryCode: countryCode,
    street: street
  }), latestDataStatus.length !== 0 ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-wrap mt-0  mr-0 mb-2"
  }, latestDataStatus) : null, setpointContent.length !== 0 ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-wrap mt-0  mr-0 mb-2"
  }, setpointContent) : null, temperatureContent.length !== 0 ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-wrap mt-0  mr-0 mb-2"
  }, temperatureContent) : null);
};

LatestDataDetails.propTypes = {
  tour: _propTypes["default"].shape({
    assetId: _propTypes["default"].number,
    status: _propTypes["default"].string.isRequired
  }).isRequired,
  latestData: _propTypes["default"].shape({
    common: _propTypes["default"].shape({
      status: _propTypes["default"].arrayOf(_propTypes["default"].shape({}))
    }),
    reefer: _propTypes["default"].shape({
      setpoints: _propTypes["default"].shape({}),
      temperatures: _propTypes["default"].shape({})
    }),
    pois: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
    position: _propTypes["default"].shape({})
  })
};
LatestDataDetails.defaultProps = {
  latestData: {
    common: {
      status: []
    },
    reefer: {
      setpoints: {},
      temperatures: {}
    }
  }
};
var _default = LatestDataDetails;
exports["default"] = _default;